var render = function render(){var _vm=this,_c=_vm._self._c;return _c('iframe',{style:(_vm.cssProps),attrs:{"src":_vm.url,"frameborder":"0"}})
}
var staticRenderFns = []

export { render, staticRenderFns }